module.exports = __webpack_public_path__ + "static/scale-model-of-witherspoon-distillery-in-lewisville-texas-5cb278a1861e67c213fd4152a469d653.png";